import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Tooltip } from "@mui/material";
import "moment/locale/hu";
import { MyHrSalarySummaryCurrencyTooltip } from "my-hr/components";
import { PayCardDataType } from "my-hr/types/paycard-data-type";
import { OcCurrency } from "oc/components";

interface MyHrSalarySummaryProps {
  data?: PayCardDataType;
}

export const MyHrSalarySummary: React.FC<MyHrSalarySummaryProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  if (!data) {
    return null;
  }
  const { netWage, otherBenefits, grossWage } = data;
  const netSalary = netWage + otherBenefits;

  const deductions = grossWage - netSalary;
  let salaryPercentage = ((100 * Math.abs(netSalary || 0)) / grossWage).toFixed(
    2,
  );
  let deductionsPercentage = 100 - Number(salaryPercentage);

  return (
    <Box
      marginTop="8px"
      marginBottom="24px"
      display="flex"
      flexDirection="row"
      alignItems="center"
      borderRadius="8px"
      overflow="hidden"
    >
      <Tooltip
        title={
          <MyHrSalarySummaryCurrencyTooltip
            label={t("MY_HR_NET_WAGE")}
            value={netSalary}
          />
        }
        placement="top"
      >
        <Box
          style={{
            width: `${salaryPercentage}%`,
            textAlign: "center",
            backgroundColor: "#cc0033",
            color: "white",
            height: "24px",
            fontSize: "12px",
            lineHeight: "24px",
          }}
        >
          {OcCurrency({ value: netSalary })}
        </Box>
      </Tooltip>
      <Tooltip
        title={
          <MyHrSalarySummaryCurrencyTooltip
            label={t("MY_HR_DEDUCTIONS")}
            value={deductions}
          />
        }
        placement="top"
      >
        <Box
          style={{
            width: `${deductionsPercentage}%`,
            textAlign: "center",
            color: "white",
            height: "24px",
            backgroundColor: "#5E6366",
            fontSize: "12px",
            lineHeight: "24px",
          }}
        >
          {OcCurrency({ value: deductions })}
        </Box>
      </Tooltip>
    </Box>
  );
};

export default MyHrSalarySummary;
